/**
 * Driver.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

export default {

  // tableName: 'choferes',

  attributes: {

    picture: {
      type: 'file',
      limit: 1
    },

    //  ╔═╗╦═╗╦╔╦╗╦╔╦╗╦╦  ╦╔═╗╔═╗
    //  ╠═╝╠╦╝║║║║║ ║ ║╚╗╔╝║╣ ╚═╗
    //  ╩  ╩╚═╩╩ ╩╩ ╩ ╩ ╚╝ ╚═╝╚═╝

    name: {
      type: 'string',
      required: true,
      // columnName: 'nombre'
    },

    rfc: {
      type: 'string',
      allowNull: false,
      required: true,
    },

    birth: {
      type: 'ref',
      columnType: 'date',
      required: true,
      // columnName: 'fecha_nacimiento'
    },

    external: {
      type: 'boolean',
      defaultsTo: false,
      // columnName: 'externo'
    },

    phone: {
      type: 'string',
      allowNull: true,
      // columnName: 'telefono'
    },

    visa: {
      type: 'string',
      allowNull: true
    },

    visaExpiration: {
      type: 'ref',
      columnType: 'date',
      // columnName: 'visa_expiracion'
    },

    fast: {
      type: 'string',
      allowNull: true,
    },

    fastExpiration: {
      type: 'ref',
      columnType: 'date',
      // columnName: 'fast_expiracion'
    },

    license: {
      type: 'string',
      required: true,
      // columnName: 'licencia'
    },

    emailAddress: {
      type: 'string',
      required: true,
      // columnName: 'licencia'
    },

    licenseExpiration: {
      type: 'ref',
      columnType: 'date',
      // columnName: 'licencia_expiracion'
    },

    //  ╔═╗╔╦╗╔╗ ╔═╗╔╦╗╔═╗
    //  ║╣ ║║║╠╩╗║╣  ║║╚═╗
    //  ╚═╝╩ ╩╚═╝╚═╝═╩╝╚═╝


    //  ╔═╗╔═╗╔═╗╔═╗╔═╗╦╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
    //  ╠═╣╚═╗╚═╗║ ║║  ║╠═╣ ║ ║║ ║║║║╚═╗
    //  ╩ ╩╚═╝╚═╝╚═╝╚═╝╩╩ ╩ ╩ ╩╚═╝╝╚╝╚═╝

    licenseType: {
      model: 'licensetype',
      // columnName: 'tipo_licencia_id'
    },

    dispatches: {
      collection: 'dispatch',
      via: 'driver'
    },

    medicalHistory: {
      collection: 'medicalexam',
      via: 'driver'
    },

    supplier: {
      model: 'supplier',
    }
  },

}



// WEBPACK FOOTER //
// ./src/models/Driver.js